/* jshint: esversion 6 */
import React from 'react';

class ErrorThumbnail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovering: false
        };

    }

    render() {
        const onmouseover = (e) => {
            this.setState({
                isHovering: true
            });
        }

        const onmouseout = (e) => {
            this.setState({
                isHovering: false
            });
        }

        const onclick = (e) => {
            let nextIsHovering = (this.state.isHovering) ? false : true;
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                isHovering: nextIsHovering
            });
        }

        if (!this.props.error) {
            return null;
        }

        let hoverError = null;
        if (this.state.isHovering) {
            hoverError = (
                <div className="error-thumb-hover">
                    <i className="fa fa-exclamation-circle"></i>{
                    this.props.error.map((error, i) => {
                        return (
                            <p key={`error-${i}`}>{error}</p>
                        );
                    })}
                </div>
            );
        }

        let removeThumb = null;
        if (this.props.hash && this.props.removeMedia) {
            removeThumb = (
                <div className="remove-thumb" data-hash={this.props.hash} role="button" aria-label="Remove Image" onClick={this.props.removeMedia}>
                    <i className="fa fa-times-circle"></i>
                </div>
            );
        }

        let thumb = null;
        if (this.props.errorThumb) {
            thumb = (
                <div className="error-container">
                    <div className="error-indicator">
                        <span className="fa-stack">
                            <i className="fa fa-circle fa-stack-2x indicator"></i>
                            <i className="fa fa-exclamation fa-stack-1x fa-inverse"></i>
                        </span>
                    </div>
                    <div className="thumb-container">
                        <img src={this.props.errorThumb.thumb} alt={this.props.error.name} title={this.props.error.name}/>
                    </div>
                </div>
            );
        } else {
            thumb = (
                <div className="default-file-thumb" alt={this.props.error.name} title={this.props.error.name}>
                    <i className="fa fa-file-o"></i>
                </div>
            );
        }

        let errorClass = "error-thumb";
        if (this.props.extraClasses) {
            errorClass += ` ${this.props.extraClasses}`;
        }

        return (
            <div className={errorClass} onClick={onclick} onMouseOver={onmouseover} onMouseOut={onmouseout}>
                {removeThumb}
                {hoverError}
                {thumb}
            </div>
        )
    }
}

export default ErrorThumbnail;
